/**
 * <FieldRow> — horizontal grouping wrapper around <Field>s.
 *
 * CSS grid; collapses to 1 column under 700px viewport.
 *
 * Props:
 *  - cols : 2 or 3 (default 2)
 *  - gap  : CSS length (default var(--space-lg))
 */
export default function FieldRow({ cols = 2, gap, children, className }) {
  const colCls = cols === 3 ? '3' : cols === 1 ? '1' : '2'
  const cls =
    'form-field-row form-field-row-' + colCls + (className ? ' ' + className : '')
  const style = gap ? { gap } : undefined
  return (
    <div className={cls} style={style}>
      {children}
    </div>
  )
}
